"use strict";

export var InlineFormConstants = {
  INLINE_FORM_SET_TITLE: 'INLINE_FORM_SET_TITLE',
  INLINE_FORM_SHOW_TABLE: 'INLINE_FORM_SHOW_TABLE',
  INLINE_FORM_SET_TABLE_ELEM: 'INLINE_FORM_SET_TABLE_ELEM',
  INLINE_FORM_LOAD_BUTTONS_DATA: 'INLINE_FORM_LOAD_BUTTONS_DATA',
  INLINE_FORM_TABLE_INITIALIZED: 'INLINE_FORM_TABLE_INITIALIZED',
  INLINE_FORM_TABLE_BUTTONS_DISABLING: 'INLINE_FORM_TABLE_BUTTONS_DISABLING',
  INLINE_FORM_SET_INSTANCE: 'INLINE_FORM_SET_INSTANCE'
};